import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

export function LikesList({
  likesInfo,
  userLimit,
  personalLike,
  showCard,
  listContainerStyle,
  listStyle,
  cardStyle,
  imageStyle,
  txtStyle,
  hanldeBoxClick,
  handleItemClick,
}) {
  const [listLength, setListLength] = useState(0);
  const [personalLikeTxt, setPersonalLikeTxt] = useState("");

  useEffect(() => {
    setListLength(likesInfo.length);
  }, [likesInfo]);

  useEffect(() => {
    let txt = "";

    if (personalLike && !showCard) {
      txt = userLimit && (listLength > userLimit || likesInfo.length === 0) ? "You" : "and You";
    }

    setPersonalLikeTxt(txt);
  }, [personalLike, userLimit, listLength]);

  return (
    <div className={`${listContainerStyle}`} onClick={hanldeBoxClick}>
      <ul className={`${listStyle}`}>
        {likesInfo
          .slice(0, userLimit - 1 || listLength - 1)
          ?.map((eachVal, index) => (
            <li key={index} onClick={handleItemClick}>
              {showCard ? (
                <div className={cardStyle}>
                  <DisplayPicture
                    image={eachVal.image}
                    className={`${imageStyle}`}
                  />
                  <span className={`${txtStyle}`}>
                    {eachVal.FirstName + eachVal.LastName}
                  </span>
                </div>
              ) : (
                <span>{eachVal.FirstName + eachVal.LastName}</span>
              )}
            </li>
          ))}
        {personalLikeTxt}
        {listLength > userLimit && ` and ${listLength - userLimit} more...`}
      </ul>
    </div>
  );
}

LikesList.propTypes = {
  likesInfo: PropTypes.object,
};
